import React from 'react';
import { useQuiz } from '../contexts/QuizContext';
import './QuizNavigation.css';

const QuizNavigation = ({ totalQuestions }) => {
  const { 
    currentQuestion, 
    nextQuestion, 
    previousQuestion, 
    answers, 
    calculateResult 
  } = useQuiz();
  
  const isLastQuestion = currentQuestion === totalQuestions - 1;
  const isAnswered = answers[`pergunta${currentQuestion + 1}`] !== undefined;
  
  const handleNext = () => {
    if (isLastQuestion) {
      calculateResult();
    } else {
      nextQuestion();
    }
  };
  
  return (
    <div className="quiz-navigation">
      <div className="progress-bar">
        <div 
          className="progress-indicator" 
          style={{ width: `${((currentQuestion + 1) / totalQuestions) * 100}%` }}
        />
      </div>
      <div className="questions-indicator">
        Pergunta {currentQuestion + 1} de {totalQuestions}
      </div>
      <div className="navigation-buttons">
        {currentQuestion > 0 && (
          <button 
            className="navigation-button back" 
            onClick={previousQuestion}
          >
            Voltar
          </button>
        )}
        <button 
          className="navigation-button next" 
          onClick={handleNext}
          disabled={!isAnswered}
        >
          {isLastQuestion ? 'Ver Resultado' : 'Próxima'}
        </button>
      </div>
    </div>
  );
};

export default QuizNavigation; 